import { FileUploader, FileUploaderFactory } from "angular-file-upload";
import Croppie from "croppie";
import * as angular from "angular";
import { User } from "../../models/user.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { UserDataProvider } from "../../data-provider/user.dp";
import { CredentialsManager } from "../../shared/credentials-manager";

let ImageCropDialogComponent = {
    selector: "vcImageCropDialog",
    templateUrl: "/angular/components/profile/image-crop-dialog.component.html",
    bindings: {},
    controller: class ImageCropDialogController {
        public imageSrc = "";
        public screen = "1";
        public saving = false;
        public croppie: Croppie;
        public user: User;
        public uploader: FileUploader;
        public imageloaded = false;

        private dialog: DialogUtils;
        private toast: ToastUtils;

        constructor(
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            UserDataProvider: UserDataProvider,
            FileUploader: FileUploaderFactory,
            CredentialsManager: CredentialsManager
        ) {
            this.dialog = DialogUtils;
            this.toast = ToastUtils;

            this.user = UserDataProvider.getActiveUser();
            this.uploader = new FileUploader({
                headers: {
                    Authorization:
                        "Bearer " + CredentialsManager.getAccessToken(),
                } as any,
                autoUpload: true,
            });

            this.testImageLoad(this.user.images.big);

            setTimeout(() => {
                angular
                    .element(document.querySelector("#image-upload-input1"))
                    .on("change", this.handleFileSelect.bind(this));
            }, 50);

            setTimeout(() => {
                angular
                    .element(document.querySelector("#image-upload-input2"))
                    .on("change", this.handleFileSelect.bind(this));
            }, 50);
        }

        testImageLoad(URL: string): void {
            let tester = new Image();
            tester.onload = this.imageFound.bind(this);
            tester.onerror = this.imageNotFound.bind(this);
            tester.src = URL;
        }

        imageFound(): void {
            this.imageloaded = true;
        }

        imageNotFound(): void {
            this.imageloaded = false;
        }

        imageURL(): string {
            return !this.user.hasprofilepic
                ? "/img/icons/new/profile-image.svg"
                : this.user.images.big;
        }

        handleFileSelect(evt: any): void {
            let file = evt.currentTarget.files[0];
            let reader = new FileReader();
            let imageType = /image.*/;

            if (file.type.match(imageType)) {
                this.destroy();
                this.screen = "2";
                reader.onload = (evt: any) => {
                    this.imageSrc = evt.target.result;
                };
                reader.readAsDataURL(file);

                setTimeout(() => {
                    this.initCropper();
                }, 300);
            } else {
                this.toast.error("File not supported");
            }
        }

        initCropper(): void {
            let img = document.getElementById("image-preview");
            this.croppie = new Croppie(img, {
                enableExif: true,
                viewport: {
                    width: 300,
                    height: 300,
                    type: "circle",
                },
                boundary: {
                    width: 520,
                    height: 320,
                },
                showZoomer: true,
            });
        }

        deletePhoto(): void {
            this.destroy();
            this.dialog.hide();
            this.user.removeProfileImage().then(
                () => this.toast.success("Profile photo deleted"),
                () => this.toast.error()
            );
        }

        cancel(): void {
            this.destroy();
            this.dialog.hide({ action: "cancel" });
        }

        destroy(): void {
            if (!this.croppie) return;

            this.croppie.destroy();
            this.croppie = null;
            this.imageSrc = "";
        }

        savePhoto(): void {
            this.saving = true;
            this.croppie
                .result({ type: "base64", size: { width: "200" } })
                .then((image: any) => {
                    this.user.setImage(image).then(
                        (json: any) => {
                            this.dialog.hide(this.user);
                            this.toast.success("Profile photo updated");
                        },
                        () => this.toast.error()
                    );
                });
        }
    },
};

angular
    .module("profile")
    .component(ImageCropDialogComponent.selector, ImageCropDialogComponent);
